import React, { useEffect, useState } from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';

import * as styles from './FooterLegal.styles';
import { FeefoAwardBadge } from 'client-site-chrome-ui/components/atoms/FeefoAwardBadge/FeefoAwardBadge';

const currentYear = new Date().getFullYear();

export const FooterLegal = () => {
  const getTrackingEvent = (evt: React.MouseEvent<HTMLAnchorElement>) => ({
    event: 'custom_event',
    event_action: 'Legal footer click',
    event_category: 'Footer',
    event_label: evt.currentTarget.textContent?.trim(),
  });
  const { trackLinkClick, trackLinkMouseDown } = useTrackableLink();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <div css={styles.container}>
      <div css={styles.awardBadge}>
        <FeefoAwardBadge />
      </div>
      <div css={styles.lists}>
        <ul css={styles.list}>
          <li>
            <a
              href="/sitemap"
              onClick={trackLinkClick(getTrackingEvent)}
              onMouseDown={trackLinkMouseDown(getTrackingEvent)}
            >
              Sitemap
            </a>
          </li>
          <li>
            <a
              href="/about/privacy-and-cookies"
              onClick={trackLinkClick(getTrackingEvent)}
              onMouseDown={trackLinkMouseDown(getTrackingEvent)}
              rel="nofollow"
            >
              Privacy and cookies
            </a>
          </li>
          <li>
            <a
              href="/about/shopper-terms"
              onClick={trackLinkClick(getTrackingEvent)}
              onMouseDown={trackLinkMouseDown(getTrackingEvent)}
              rel="nofollow"
            >
              Terms and conditions
            </a>
          </li>
        </ul>
        <ul css={styles.list}>
          {isClient && <li>Copyright &copy; 2006-{currentYear}</li>}
          <li>Notonthehighstreet Enterprises Limited</li>
        </ul>
      </div>
    </div>
  );
};
